module.exports = __webpack_public_path__ + "static/media/users.3a969d59.jpg";